import axios from "axios";
import { applyEncryptionInterceptor } from "./encryption";

// Base API URL
// const BASE_URL = "http://localhost:8000/api/";
const BASE_URL = "https://service.litegrocer.lk/api/";

// Base Image URL (no /api/ here)
// const IMAGE_BASE_URL = "http://localhost:8000/storage/";
const IMAGE_BASE_URL = "https://service.litegrocer.lk/";

// Axios instance for API requests
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

applyEncryptionInterceptor(api);

// Optional: Interceptors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export { BASE_URL, IMAGE_BASE_URL }; // ✅ Export both
export default api;
